import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Box, Button, Stack, Typography } from "@components/base";

interface NoFormsYet {
  onCreateForm: () => void;
}

const NoFormsYet: FC<NoFormsYet> = ({ onCreateForm }) => {
  const { t } = useTranslation();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height={"calc(100vh - 148px)"}
    >
      <Stack spacing={3} alignItems="center">
        <img
          src={`/static/cards/magnifier-green.svg`}
          width={240}
          height={190}
          alt={"magnifier-green"}
        />
        <Box>
          <Typography variant="subtitle1" align="center" gutterBottom>
            {t("noForms.title")}
          </Typography>
          <Typography align="center">{t("noForms.text")}</Typography>
        </Box>
        <Button onClick={onCreateForm}>{t("noForms.cta")}</Button>
      </Stack>
    </Stack>
  );
};

export default NoFormsYet;
